module.exports = __webpack_public_path__ + "static/media/Favourites_Purple@3x.c0392e0d.png";